import { PermissionActions } from 'src/services/posts';

export const PERMISSIONS_ACTIONS: Record<PermissionActions, PermissionActions> = {
  BLOCK_ADMIN_CREATE: 'BLOCK_ADMIN_CREATE',
  BLOCK_CREATE: 'BLOCK_CREATE',
  BLOCK_DELETE: 'BLOCK_DELETE',
  BLOCK_MEMBER_CREATE: 'BLOCK_MEMBER_CREATE',
  BLOCK_MODERATOR_CREATE: 'BLOCK_MODERATOR_CREATE',
  BLOCK_READ: 'BLOCK_READ',
  COLLECTION_DELETE: 'COLLECTION_DELETE',
  COLLECTION_UPDATE: 'COLLECTION_UPDATE',
  COMMENT_DELETE: 'COMMENT_DELETE',
  COMMENT_HIDE: 'COMMENT_HIDE',
  COMMENT_SORTITION_CREATE: 'COMMENT_SORTITION_CREATE',
  COMMUNITY_ADMIN_ONBOARDING_VIEW: 'COMMUNITY_ADMIN_ONBOARDING_VIEW',
  FOLLOW_REQUEST_READ: 'FOLLOW_REQUEST_READ',
  FOLLOW_REQUEST_UPDATE: 'FOLLOW_REQUEST_UPDATE',
  GROUP_CREATE: 'GROUP_CREATE',
  GROUP_DELETE: 'GROUP_DELETE',
  GROUP_READ: 'GROUP_READ',
  GROUP_UPDATE: 'GROUP_UPDATE',
  MEMBER_DELETE: 'MEMBER_DELETE',
  MEMBER_ROLE_READ: 'MEMBER_ROLE_READ',
  MEMBER_UPDATE: 'MEMBER_UPDATE',
  PIN_CREATE: 'PIN_CREATE',
  PIN_DELETE: 'PIN_DELETE',
  POST_CREATE: 'POST_CREATE',
  POST_DELETE: 'POST_DELETE',
  POST_REVIEW_UPDATE: 'POST_REVIEW_UPDATE',
  SCHEDULED_POST_CREATE: 'SCHEDULED_POST_CREATE',
  SCHEDULED_POST_DELETE: 'SCHEDULED_POST_DELETE',
  SCHEDULED_POST_READ: 'SCHEDULED_POST_READ',
  STRIKE_CREATE: 'STRIKE_CREATE',
  STRIKE_DELETE: 'STRIKE_DELETE',
  STRIKE_READ: 'STRIKE_READ',
  WEBINAR_CREATE: 'WEBINAR_CREATE',
  VIEW_LIVE_REPORT: 'VIEW_LIVE_REPORT',
  COMMUNITY_LIVE_BETA: 'COMMUNITY_LIVE_BETA'
};
